var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',{attrs:{"autocomplete":"email","label":"Email"}})}
var staticRenderFns = []

export { render, staticRenderFns }